module.exports = __webpack_public_path__ + "img/horizontal_6_6_pp13_6005.5cecf21a.png";